export function capitalizar(str) {
    if (!str) return "";
    return str
        .split(/(\s+)/)
        .map(word => {
            // Preservar palabras con puntos (siglas: I.P.V., P.R.Yr., S.A.)
            if (/\./.test(word)) return word;
            return word.toLowerCase().replace(/^./, c => c.toUpperCase());
        })
        .join('');
}